import React, {useRef} from 'react'
import { FaTimes, FaBars } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const Header = () => {
  /* eslint-disable no-unused-vars */
  let open = false;
  /* eslint-enable no-unused-vars */

  const navRef = useRef();

  const showNavbar = () => {
    navRef.current.classList.toggle('responsive_nav');
    open = true;
  }
  
  const useLinkClickHandler = () => {
    navRef.current.classList.toggle('responsive_nav');
    open = false;
  }

  return (
    <header>
      <nav id='navbar-links' ref={navRef} >
        <Link onClick={useLinkClickHandler} to='/'>Home</Link>
        <Link onClick={useLinkClickHandler} to='/projects'>Project</Link>
        <Link onClick={useLinkClickHandler} to='/articles'>Article</Link>
        <Link onClick={useLinkClickHandler} to='/contact-me'>Contact Me</Link>
        <Link onClick={useLinkClickHandler} to='/about-me'>About Me</Link>
        <button className='nav-btn nav-close-btn close-button' onClick={showNavbar}>
          <FaTimes />
        </button>
      </nav>
      <button className='nav-btn header-bar-icon' onClick={showNavbar}>
        <FaBars />
      </button>
    </header>
  )
}

export default Header